export function isDesktop(): boolean {
  const breakpoint = 1024;
  return window.innerWidth >= breakpoint;
}

export function isBarcodeDetectorSupported(): boolean {
  return "BarcodeDetector" in window;
}
